import React, { useEffect, useState, useContext } from 'react'
import { ENV } from 'gatsby-env-variables'
import { Experiment, Variant } from 'react-optimize'
import Header from './components/Header/index.js'
import LandingHero from './components/LandingHero/index.js'
import LandingHeroHoliday from './components/LandingHeroHoliday/index.js'
import LandingFeatures from './components/LandingFeatures/index.js'
import LandingPartners from './components/LandingPartners/index.js'
import LandingAdvantages from './components/LandingAdvantages/index.js'
import LandingDescription from './components/LandingDescription/index.js'
import LandingServicing from './components/LandingServicing/index.js'
import LandingExpress from './components/LandingExpress/index.js'
import LandingEmail from './components/LandingEmail/index.js'
import LandingFaq from './components/LandingFaq/index.js'
import LandingFooter from './components/LandingFooter/index.js'
import WhatsAppButton from 'components/WhatsAppButton'
import LandingLayout from '../../layouts/LandingLayout'
import storage from 'utils/storage'
import { getOptimizeVariant } from 'utils/getOptimizeVariant'
import GA from 'utils/GA'
import If from '@mobi/components/If'
import featureToggle from 'utils/featureToggle'
import { addNRPageView } from 'utils/newRelicEvents.js'
const { lpWppButton } = featureToggle()
import isClient from 'utils/isClient.js'
import analyticsUuid from 'utils/analyticsUuid.js'
import { ThemeContext } from 'modules/Theme'
import './Landing.scss'
import handleInternalTracking from 'utils/GA/handleInternalTracking.js'

const ITAU_THEME_EXPERIENCE_ID =
  ENV === 'prod' ? 'dteP3JvyScSNb607ekuOcg' : 'BUZwjt_VTUeM42bx4LqQXw'

const DynamicComponent = ({ blok, location, holiday, overlap, isItauExp }) => {
  const isItauThemeExperience = storage.local.getItem(
    'is-itau-theme-experience'
  )

  let Components = {
    lp_header: Header,
    lp_express: LandingExpress,
    lp_servicing: LandingServicing,
    lp_features: LandingFeatures,
    lp_partners: LandingPartners,
    lp_advantages: LandingAdvantages,
    lp_description: LandingDescription,
    lp_faq: LandingFaq,
    lp_email: LandingEmail,
    lp_footer: LandingFooter,
  }

  if (isItauExp || isItauThemeExperience) {
    Components = { ...Components, lp_hero: LandingHero }
  } else if (holiday && !isItauExp) {
    Components = { ...Components, lp_hero_holiday: LandingHeroHoliday }
  } else {
    Components = { ...Components, lp_hero: LandingHero }
  }

  const Component = Components[blok.component]

  return Component ? (
    <Component
      blok={blok}
      location={location}
      holiday={holiday}
      overlap={overlap}
    />
  ) : null
}

const Landing = ({ location, pageContext }) => {
  const [isItauExp, setIsItauExp] = useState(() => {
    if (storage.local.getItem('is-itau-theme-experience') === 'true') {
      return true
    }
    false
  })

  const { setTheme } = useContext(ThemeContext)

  useEffect(() => {
    analyticsUuid.clearKeepingAnalyticsUuid()

    storage.local.setItem('callbackUrl', isClient() && window.location.href)

    storage.session.setItem('keepSession', true)

    storage.local.removeItem('isLojasAvenida')

    const isLojasAvenida = storage.local.getItem('isLojasAvenida')
    const origin = isLojasAvenida ? 'recovery' : pageContext?.slug
    setTheme(origin || 'recovery')

    if (window.location.href.includes('lojasavenida')) {
      storage.local.setItem('isLojasAvenida', true)
    }

    GA.addGTM()

    addNRPageView('lp_home')
    GA.pageLoad('LandingPage:RenegocieGrupoRecovery:RV')
    handleInternalTracking('lp_visit')
  }, [])

  useEffect(() => {
    const isLojasAvenida = storage.local.getItem('isLojasAvenida')
    const origin = isLojasAvenida ? 'recovery' : pageContext?.slug

    if (!window.google_optimize || window.google_optimize === 'undefined') {
      setTheme(origin || 'recovery')
      storage.local.setItem('is-itau-theme-experience', false)
      setIsItauExp(false)
    }

    getOptimizeVariant(ITAU_THEME_EXPERIENCE_ID)
      .then((variant) => {
        if (variant === '1') {
          setTheme('itaucard')

          storage.local.setItem('is-itau-theme-experience', true)
          setIsItauExp(true)
        } else {
          setTheme(origin || 'recovery')

          storage.local.setItem('is-itau-theme-experience', false)
          setIsItauExp(false)
        }
      })
      .catch(console.error)
  }, [isItauExp])

  let blok = pageContext?.data?.content
  blok = blok && JSON.parse(blok)

  const content = blok?.body?.map((childBlok) => (
    <DynamicComponent
      blok={childBlok}
      key={childBlok._uid}
      location={location}
      holiday={blok.holiday}
      overlap={blok.overlap_header}
      isItauExp={isItauExp}
    />
  ))

  return (
    <LandingLayout>
      <If
        condition={lpWppButton}
        renderIf={
          <WhatsAppButton
            content={blok?.body?.find(
              ({ component }) => component === 'lp_whatsapp'
            )}
          />
        }
      />
      <Experiment
        id={ITAU_THEME_EXPERIENCE_ID}
        loader={
          <div
            className="itau-theme-loader"
            aria-live="polite"
            aria-busy="true"
            aria-label="Carregando..."
          />
        }
      >
        <Variant id="0">
          <div className="landing-container">{content ? content : null}</div>
        </Variant>
        <Variant id="1">
          <div className="landing-container landing-container--itau-theme">
            {content ? content : null}
          </div>
        </Variant>
      </Experiment>
    </LandingLayout>
  )
}

export default Landing
